import { Box, Typography, Snackbar, Alert } from '@mui/material';
import React, { useState } from 'react';

export default function Dashboard() {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h3" gutterBottom>Dashboard</Typography>
      <Alert severity="info" sx={{ mb: 2 }}>View and manage your bookings and move details here.</Alert>
      <Typography variant="body1">View and manage your bookings and move details here.</Typography>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={() => setSnackbar(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} sx={{ width: '100%' }}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
